export const COMMON_MAIN_BASE_URL = "https://apis.travasco.com";
// export const COMMON_MAIN_BASE_URL = "https://uatapis.travasco.com"
// export const COMMON_MAIN_BASE_URL = "http://localhost:8080"
//export const COMMON_MAIN_BASE_URL = "https://3.7.73.108:8080";
//export const COMMON_MAIN_BASE_URL="http://13.201.168.192:8080"
export const COMMON_BASE_URL = `${COMMON_MAIN_BASE_URL}/api`;

export const SAVE_BOOKING = `${COMMON_BASE_URL}/saveBooking`
export const SAVE_FLIGHT_BOOKING = `${COMMON_BASE_URL}/flight/saveFlightBooking`;
export const MAKE_PAYMENT_SESSION = `${COMMON_BASE_URL}/flight/make-payment-session`;
export const VERIFY_PAYMENT = `${COMMON_BASE_URL}/flight/verify-payment`;

export const BASE_URL = `${COMMON_MAIN_BASE_URL}/api/flight`;
export const GET_MARKUP_SETTINGS = `${COMMON_MAIN_BASE_URL}/api/settings`
// export const POST_MARKUP_SETTINGS =`${COMMON_MAIN_BASE_URL}/api/settings`
//New B@B portal API
export const B2B_PORTAL_REGISTER = `${COMMON_BASE_URL}/b2b/register`;
export const B2B_PORTAL_LOGIN = `${COMMON_BASE_URL}/b2b/login`;